export class StatusFilter {
    public icon!: string | undefined;
    public name!: string;

    public constructor(icon: string | undefined, name: string){
        this.icon = icon;
        this.name = name;
    }
}
